// @mui
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { Avatar, Chip, ListItemText, Typography } from '@mui/material';
// hooks
// components
import { fTimestamp } from 'src/utils/format-time';
// types
import { DoorAccessDto } from '../../api';
//
import { useLocales } from '../../locales';

// ----------------------------------------------------------------------

type Props = {
  row: DoorAccessDto;
  onViewRowCustomer: VoidFunction;
};

export default function DoorAccessTableRow({ row, onViewRowCustomer }: Props) {
  const {
    timestamp,
    deviceId,
    externalId,
    result,
    accountEmail,
    accountName,
    accountProfileImageUrl,
  } = row;

  const { t } = useLocales();

  const getStatus = (() => {
    const r = result as any;
    if (r.status === 'Succeeded')
      return <Chip size="small" color="success" label={t('Succeeded')} />;
    if (r.status === 'Failed') return <Chip size="small" color="error" label={t('Failed')} />;
    return <Chip size="small" label={t('Unknown')} color="warning" />;
  })();

  return (
    <TableRow hover>
      <TableCell align="left">{fTimestamp(timestamp)}</TableCell>

      <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar
          src={accountProfileImageUrl}
          alt={accountName}
          sx={{ mr: 2 }}
          onClick={onViewRowCustomer}
        >
          {accountName?.charAt(0).toUpperCase()}
        </Avatar>

        <ListItemText
          onClick={onViewRowCustomer}
          disableTypography
          primary={
            <Typography variant="body2" noWrap>
              {accountName}
            </Typography>
          }
          secondary={
            <Typography variant="body2" noWrap>
              {accountEmail}
            </Typography>
          }
        />
      </TableCell>

      <TableCell align="left">{deviceId}</TableCell>

      <TableCell align="left">{externalId}</TableCell>

      <TableCell align="left">{getStatus}</TableCell>
    </TableRow>
  );
}
